<div class="form-group">
  <label class="control-label col-form-label-sm">{{label}}</label>
  <ng-select class="custom" [items]="options" bindValue="value" bindLabel="label" [(ngModel)]="model"
    (change)="change()"></ng-select>
  <div class="text-danger" *ngIf="errorText !== ''">
    {{errorText | translate}}
  </div>
</div>